module.exports = __webpack_public_path__ + "img/iconEmailNavy.41cbe8c5.svg";